// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"a5af56ac","284":"1a425cf1","324":"365abf7e","327":"b3da5464","453":"4fbad7c7","656":"03c6a7e1","671":"0d115aaa","721":"f9668d7d","836":"e8932b4b","898":"91155bc0","956":"1c7deb32"}[chunkId] + ".chunk.js";
};